import HotelOfferFactory from '@/js/common/Domain/Factory/HotelOfferFactory';
import getTourFirstPaymentDefinitionService from '@/js/common/Domain/Service/getTourFirstPaymentDefinition';
import countryConditions from '@ve/components/countryConditions/common/store/countryConditions';
import OperatorsRepository from '@/js/common/Domain/Repository/Operators';
import apiHotelOffersToHotelOffersProduct from '@/js/common/Domain/Service/search/apiHotelOffersToHotelOffersProduct';
import HotelOfferProduct from '@/js/common/Domain/Factory/HotelOfferProduct';

import { productCompareKey, rawProductCompareKey } from '@/js/common/Domain/Service/search/getCompareKeys';
import populateRoomDescriptions from './populateRoomDescriptions';

const createHotelOfferProducts = (hotelOffers) => _.map(hotelOffers, (hotelOffer) => new HotelOfferProduct({
    hotelOffer,
}));

export default function updateHotelOffers(data) {
    const operatorsRepository = OperatorsRepository.repository;

    const {
        searchData,
        tourProductsRepository,
        hotelOffersRepository,
    } = data;

    const {
        hotelOffers,
        countries,
        rooms = [],
        operators = [],
        firstPaymentDefinitions = [],
    } = searchData;

    operatorsRepository.add(operators);

    if (typeof console !== 'undefined' && typeof console.log === 'function') {
        console.time('builHotelOffers');
    }

    if (countries) {
        countryConditions.update(countries);
    }

    const hotelOffersWithRoomDescriptions = populateRoomDescriptions({
        hotelOffers,
        rooms,
    });

    const populatedHotelOffers = apiHotelOffersToHotelOffersProduct({
        hotelOffers: hotelOffersWithRoomDescriptions,
        firstPaymentDefinitions,
    });

    if (typeof console !== 'undefined' && typeof console.log === 'function') {
        console.log('HotelOffers from request:', populatedHotelOffers?.length || 0);
    }

    const currentHotelOffersIndex = hotelOffersRepository.map(productCompareKey);

    if (populatedHotelOffers) {
        const newTourProductModels = _.reduce(populatedHotelOffers, (newHotelOffers, rawHotelOffer) => {
            const rawProductKey = rawProductCompareKey(rawHotelOffer);
            if (!~_.indexOf(currentHotelOffersIndex, rawProductKey)) {
                const firstPaymentDefinition = getTourFirstPaymentDefinitionService(rawHotelOffer);
                const allFirstPaymentDefinitions = rawHotelOffer?.firstPaymentDefinitions || [];

                newHotelOffers.push(new HotelOfferFactory({
                    ...rawHotelOffer,
                    firstPaymentDefinition,
                    allFirstPaymentDefinitions,
                }));
            }

            return newHotelOffers;
        }, []);

        hotelOffersRepository.add(newTourProductModels, {
            merge: true,
        });
        const hotelOfferProducts = createHotelOfferProducts(newTourProductModels);
        tourProductsRepository.add(hotelOfferProducts, {
            merge: true,
        });

        if (typeof console !== 'undefined' && typeof console.log === 'function') {
            console.timeEnd('builHotelOffers');
            console.log('Added new hotelOffers:', hotelOfferProducts.length);
        }

        return hotelOfferProducts;
    }

    return [];
}
